import React from 'react';

import { SVGComponentProps } from './svg.types';

const ImportSVG = ({
  stroke = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path d="M8 2V10" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M5.33337 7.33334L8.00004 10L10.6667 7.33334"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.33337 3.33334H2.66671C2.31309 3.33334 1.97395 3.47382 1.7239 3.72387C1.47385 3.97392 1.33337 4.31305 1.33337 4.66668V11.3333C1.33337 11.687 1.47385 12.0261 1.7239 12.2762C1.97395 12.5262 2.31309 12.6667 2.66671 12.6667H13.3334C13.687 12.6667 14.0261 12.5262 14.2762 12.2762C14.5262 12.0261 14.6667 11.687 14.6667 11.3333V4.66668C14.6667 4.31305 14.5262 3.97392 14.2762 3.72387C14.0261 3.47382 13.687 3.33334 13.3334 3.33334H10.6667"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export default ImportSVG;
